import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

@Component({
  selector: 'app-md-other',
  templateUrl: './md-other.component.html',
  styleUrls: ['./md-other.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MdOtherComponent  extends DestructorComponent implements OnInit {

   otherDataChildren: Route[] = [];
   user:any;

    constructor(private router: Router, private _globalStateService: GlobalStateService) { super(); }

    ngOnInit(): void {
      // Find the master-data route first
      const masterDataRoute = this.router.config.find(r => r.path === 'master-data');

      // Then find the 'other' child route within master-data
      const otherRoute = masterDataRoute?.children?.find(child => child.path === 'other');

      // Get the third-level children (auction-hall, documents, etc.)
      this.otherDataChildren = otherRoute?.children ?? [];

      this.subscriptions.push(
        this._globalStateService.user.subscribe(user => {
          this.user = user;

          if (this.user?.role_complete.is_admin) {
            this.otherDataChildren = otherRoute?.children ?? [];
          }
          else {
            console.log("permission ;;--->",this.user?.role_complete.permissions['other'])
            this.otherDataChildren = this.otherDataChildren.filter((child: any) => {
              return this.user?.role_complete.permissions['other'] && this.user?.role_complete.permissions['other'][child.path];
            });
          }
        })
      );
    }
}
